import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import ScrollToTop from '../components/ScrollToTop';

import likeAnAdapter from '../../assets/images/brokersTechnologyChampions/likeAnAdapter.png';
import gettingDataMoving from '../../assets/images/brokersTechnologyChampions/gettingDataMoving.png';
import definedPolicyInquiry from '../../assets/images/brokersTechnologyChampions/definedPolicyInquiry.png';
import jsonTheLatest from '../../assets/images/brokersTechnologyChampions/jsonTheLatest.png';
import takingYourEducationExperience2 from '../../assets/images/brokersTechnologyChampions/takingYourEducationExperience2.png';
import registerEasily from '../../assets/images/brokersTechnologyChampions/registerEasily.png';
import monitorYourStatus from '../../assets/images/brokersTechnologyChampions/monitorYourStatus.png';
import instantlyDownload from '../../assets/images/brokersTechnologyChampions/instantlyDownload.png';
// import free from '../../assets/images/brokersTechnologyChampions/free.png';
// import accredited from '../../assets/images/brokersTechnologyChampions/accredited.png';
// import onDemand from '../../assets/images/brokersTechnologyChampions/onDemand.png';
import vanAlanInsurance from '../../assets/images/brokersTechnologyChampions/vanAllen.gif';

const BrokersTechnologyChampions = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  const videoPlayerWidth = (width > MAX_WIDTH ? MAX_WIDTH : width) / 2;
  const videoPlayerHeight = videoPlayerWidth * .618;

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            <span style={{ color: '#00546F' }}>BROKERS'</span> TECHNOLOGY CHAMPIONS
          </h2>
          <p style={{ marginTop: 30 }} class="greenP">
            As our industry changes, nobody can afford to lag behind in technology. CSIO members
            can look to us to make it easier to keep up.
          </p>
          <p class="greenP">
            CSIO brings the industry together to create technology solutions with a purpose. We
            work with members to discover their pain points. Then we collaborate to set priorities,
            investigate options and standardize solutions. Together, we create solutions that members
            couldn’t develop alone.
          </p>
          <p class="greenP">
            Whether it’s adopting new technology to smooth operations, meeting changing customer
            demands or understanding cybersecurity, CSIO is the champion for brokers’ technology
            interests. And like technology, our programs and solutions never stop evolving.
          </p>
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="innotech-and-emerging-technology" tabIndex="-1">
            INNOTECH APPLICATION PROGRAM INTERFACE (API)
          </h3>
          <p style={{ marginTop: 30 }}>
            2021 saw CSIO begin a project that will make the industry’s data move faster than ever before.
          </p>
          <p>
            We’re a data-heavy industry. Multiple players—insurers, vendors and brokers—means requesting
            or transferring information requires different portals, platforms, processes. The systems weren’t
            designed to talk to one another, which leads to manual processes and multiple authentications to get
            information. This causes major slowdowns.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 30
          }}>
            <img
              src={likeAnAdapter}
              height="80px"
              width="80px"
              alt=""
            />
            <div style={{ color: '#00546F', fontFamily: 'montserrat bold', fontSize: 16, marginLeft: 12 }}>
              LIKE AN ADAPTER, AN API CAN MAKE IT
              ALL FIT TOGETHER NICELY
            </div>
          </div>
          {/* <CallHighlights /> */}
          <p style={{ marginTop: 30 }}>
            In 2021, we started creating an advanced solution to vastly speed up the movement of information.
            Our aim is to give brokers real-time policy-level information in their broker management systems
            (BMS), thanks to standardizing APIs.
          </p>
          <h5 className='benefitsAtAGlance'>
            BENEFITS AT A GLANCE
          </h5>
          <ul>
            <li class="keyBenefits">
              Sweeps away the hassle of multiple portals, processes and authentications
            </li>
            <li class="keyBenefits">
              Creates fluid information delivery
            </li>
            <li class="keyBenefits">
              Offers real-time access to policy information in a BMS
            </li>
            <li class="keyBenefits">
              Takes the customer and broker experience from stalled to stellar
            </li>
          </ul>
          <p style={{ marginTop: 30 }}>
            2021 also saw the Working Groups start advancing an API security standard. The standard will
            advance the enablement to authorize and authenticate users. This is the first critical step toward
            addressing authentication pain points in the broker channel.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <div style={{ color: '#00546F', fontFamily: 'montserrat bold', fontSize: 16, marginRight: 12 }}>
              GETTING DATA MOVING FASTER MEANS OUR
              WORKING GROUPS <span style={{ color: '#849F76', fontSize: 22 }}>WORKED FAST IN 2021</span>
            </div>
            <img
              src={gettingDataMoving}
              height="80px"
              width="80px"
              alt=""
            />
          </div>
          <Row style={{ marginTop: 30 }}>
            <Col>
              <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase' }}>
                DEFINED POLICY INQUIRY BUSINESS REQUIREMENTS FOR:
              </h5>
              <ul>
                <li class="keyBenefits">
                  Personal automobile and habitational insurance
                </li>
                <li class="keyBenefits">
                  Commercial lines: Individually Rated Commercial Automobile (IRCA) and Commercial General
                  Liability (CGL)
                </li>
              </ul>
              <br />
              <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase' }}>
                DEVELOPED AND PUBLISHED API STANDARDS USING JSON—JAVA SCRIPT OBJECT NOTATION
              </h5>
              <p>
                Laid foundation for the API security model:
              </p>
              <ul>
                <li class="keyBenefits">
                  Identifying needs and specifications
                </li>
                <li class="keyBenefits">
                  Collaborating with API security vendor to develop the standard
                </li>
              </ul>
            </Col>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img
                src={definedPolicyInquiry}
                width='100%'
                height='auto'
                alt="Two men shake hands"
              />
            </Col>
          </Row>
          <br />
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <img
              src={jsonTheLatest}
              height="80px"
              width="80px"
              alt=""
            />
            <div style={{ color: '#00546F', fontFamily: 'montserrat bold', fontSize: 22, marginLeft: 12 }}>
              <span style={{ color: '#1B526D' }}>JSON:</span> <span style={{ color: '#849F76', fontSize: 20 }}>THE LATEST STATE-OF-THE-ART TECHNOLOGY FOR</span> REAL-TIME DATA INTERCHANGE FOR APIs
            </div>
          </div>
          <br />
          <h6 style={{ color: "#1B526D", marginTop: 30 }}>
            We’re taking it to the next level by using JSON
          </h6>
          <p>
            This is the Property and Casualty (P&C) industry’s first API standard to use JSON. It’s a milestone
            because previous Standards using EDI and XML are not aligned to digital Standards expected for
            data exchange.
          </p>

          <blockquote>
          “Consumers are accustomed to receiving information in real-time as they make buying decisions, and they expect the same experience when it comes to their property and casualty insurance policies. As an INNOTECH Advisory Committee member, I am pleased to see the API digital solutions we proposed come to fruition. Standardizing APIs in JSON format allows insurer and vendor members to structure their data in an agreed-upon format, resulting in faster, more efficient transactions for brokers and an improved digital experience for customers.”
            <span>Derek Oke, Senior Director,<br/>Solutions Architecture at Travelers Canada</span>
          </blockquote>

          <p style={{ fontSize: 20, textAlign: 'center', marginTop: 30, marginBottom: 30 }}>
            Meet the Working Group members <a href="https://csio.com/solutions-tools/innotech-committee/working-group" alt="CSIO.com's Working Group members webpage" style={{ fontWeight: 'bold' }}><strong>here</strong></a> making API standardization a reality.
          </p>
          <h3 style={{ marginTop: 60 }} id="professional-development">
            PROFESSIONAL DEVELOPMENT
          </h3>
          <p>
            CSIO’s education program had a name change in 2021. eLearning became Professional Development.
            But that’s just the icing on the cake.
          </p>
          <p>
            With the refresh of CSIO.com, we created a new education experience. One that makes it easier to
            learn—and easier to track progress.
          </p>
          <h4 style={{ color: '#48604C', textTransform: 'uppercase', marginTop: 60, marginBottom: 30 }}>
            TAKING YOUR EDUCATION EXPERIENCE TO NEW HEIGHTS
          </h4>
          <img
            src={takingYourEducationExperience2}
            width="100%"
            height="auto"
            alt="A timeline of achievements since 2018. 2018: Introduced a 3 part cybersecurity online course, in response to member requests, 450 members registered in the first six weeks. 2019: Launched accredited on-demand, free, member courses with 14 new courses over three streams: cybersecurity, digital marketing, insurance technology. 1507 members registered for courses and webinars. 2020: expanded the program with 12 courses and 40 webinars. CSIO's accredited online courses meant members continued to get CE credits to maintain licenses when conferences and events were cancelled during the pandemic. Launched the digital member program, recognizing members who have completed at least six CSIO courses. 4000 brokers enrolled in webinars and courses. 2021: 10 new courses, 10 webinars, plus a new online education dashboard to make professional development easier. Record number of over 1400 members signed up for on-demand learning courses."
          />
          <h4 style={{ color: '#48604C', textTransform: 'uppercase', marginTop: 60, marginBottom: 30 }}>
            The Professional Development dashboard puts you in control
            of your learning
          </h4>
          <p>
            The new Dashboard, available on CSIO.com, lets you track and build your CSIO education progress all
            in one place.
          </p>
          <Row>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}>
              <img
                src={registerEasily}
                height="80px"
                width="72px"
                alt=""
              />
              <div style={{ textAlign: 'center', marginTop: 30 }}>
                <span style={{ fontFamily: 'montserrat bold', color: '#1B526D' }}>Register easily</span> for accredited
                courses and webinars
              </div>
            </Col>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
              <img
                src={monitorYourStatus}
                height="80px"
                width="92px"
                alt=""
              />
              <div style={{ textAlign: 'center', marginTop: 30 }}>
                <span style={{ fontFamily: 'montserrat bold', color: '#1B526D' }}>Monitor your status</span> towards the Digital Member
                designation
              </div>
            </Col>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
              <img
                src={instantlyDownload}
                height="80px"
                width="64px"
                alt=""
              />
              <div style={{ textAlign: 'center', marginTop: 30 }}>
                <span style={{ fontFamily: 'montserrat bold', color: '#1B526D' }}>Instantly download your
                  certificates</span> to all completed
                courses and webinars
              </div>
            </Col>
          </Row>
          {/* <h5 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginBottom: 30, marginTop: 30 }}>
            ALL THE COURSES REMAIN:
          </h5>
          <Row>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}>
              <div style={{
                backgroundColor: '#F9F9F6',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: 180,
                height: 180,
                borderRadius: 90
              }}>
                <div style={{ textAlign: 'center', marginBottom: 12, fontFamily: 'montserrat bold' }}>
                  FREE
                </div>
                <img
                  src={free}
                  height="60px"
                  width="60px"
                  alt=""
                />
              </div>

            </Col>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
              <div style={{
                backgroundColor: '#F3F7F8',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: 180,
                height: 180,
                borderRadius: 90
              }}>
                <div style={{ textAlign: 'center', marginBottom: 12, fontFamily: 'montserrat bold' }}>
                  ACCREDITED
                </div>
                <img
                  src={accredited}
                  height="60px"
                  width="48px"
                  alt=""
                />
              </div>

            </Col>
            <Col style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
              <div style={{
                backgroundColor: '#FFFBEE',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: 180,
                height: 180,
                borderRadius: 90
              }}>
                <div style={{ textAlign: 'center', marginBottom: 12, fontFamily: 'montserrat bold' }}>
                  ON-DEMAND
                </div>
                <img
                  src={onDemand}
                  height="60px"
                  width="88px"
                  alt=""
                />
              </div>

            </Col>
          </Row> */}
          <h4 style={{ color: '#48604C', textTransform: 'uppercase', marginTop: 60, marginBottom: 30 }}>
            Van Allen Insurance Scales a New Peak
          </h4>
          <p>
            <a href="https://csio.com/sites/default/files/2022-01/CU%20Magazine%20Print%20Ad_Van%20Allen%20Congrats%20Final.pdf" alt="pdf of Van allen insurance members">Congratulations</a> to Van Allen Insurance! They are the first brokerage with every staff member earning their CSIO Digital Broker designation.
          </p>
          <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 30
          }}>
            <img
              src={vanAlanInsurance}
              width='50%'
              height='auto'
              alt="Congratulations to Van Allen Insurance!"
            />
          </div>

          <h4 style={{ color: '#1C1F3D', textTransform: 'uppercase', marginTop: 60 }}>
            see how easy it is to earn your credits through CSIO
          </h4>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: 30,
            marginBottom: 30
          }}>
            <iframe width={`${videoPlayerWidth}`} height={`${videoPlayerHeight}`} src="https://www.youtube.com/embed/Ktb8puBEx7I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <blockquote>
          “We made it a priority for all of our employees to take CSIO’s Professional Development Program. The fact that the courses are free, relevant and engaging, made it an ideal way for our brokerage staff to enhance their digital knowledge and get their Registered Insurance Brokers of Ontario (RIBO) Continuing Education (CE) credits. The Cybersecurity and Ransomware courses armed the team with the knowledge to avoid phishing campaigns and keep the brokerage and its clients safe, and the courses on Digital Marketing and SEO are helping digitize our brokerage.”
            <span>Sarah Van Allen, Owner of Van Allen Insurance Inc</span>
          </blockquote>

        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default BrokersTechnologyChampions;
